 //export const siteUrl = "http://api.agros.az/";
export const siteUrl = "https://api.aictia.org/api/root/";
//export const siteUrl = "http://dev.agros.az/";
export const localUrl = "https://localhost:44362/";

export default siteUrl;
